export default __webpack_public_path__ + "static/media/NFT6.7badbf24.png";